import { render, staticRenderFns } from "./CollapsePopover.vue?vue&type=template&id=57514898&scoped=true&"
import script from "./CollapsePopover.vue?vue&type=script&lang=js&"
export * from "./CollapsePopover.vue?vue&type=script&lang=js&"
import style0 from "./CollapsePopover.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./CollapsePopover.vue?vue&type=style&index=1&id=57514898&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57514898",
  null
  
)

export default component.exports